import { FC } from 'react';

import CreditCardAdd from 'components/credit-card-add';
import { CREDIT_CARD_ADD_PAY } from 'utils/constants';

const CreditCardPay: FC = () => <CreditCardAdd intent={CREDIT_CARD_ADD_PAY} />;

export default CreditCardPay;
